var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20px",
    height: "20px",
    viewBox: "0 0 420.000000 368.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,368.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1285 3238 c-2 -13 -12 -54 -20 -93 -83 -375 -201 -492 -585 -579 -53 -11 -98 -25 -100 -31 -3 -5 61 -26 142 -46 255 -64 369 -138 446 -286 48 -94 69 -156 97 -287 22 -102 39 -130 50 -79 56 259 103 378 188 469 84 91 204 147 420 195 54 12 97 27 97 33 0 6 -28 17 -62 23 -108 21 -240 62 -316 99 -174 85 -249 217 -326 577 -8 33 -24 35 -31 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2623 2652 c-7 -5 -17 -30 -22 -58 -51 -265 -129 -467 -223 -580 -114 -137 -247 -205 -546 -280 -97 -24 -177 -46 -180 -49 -13 -13 11 -35 45 -40 82 -15 278 -67 355 -95 304 -111 436 -291 533 -725 14 -66 31 -124 36 -130 17 -17 36 19 54 105 45 217 118 409 198 516 109 148 317 249 652 320 44 9 84 20 89 25 18 16 -15 37 -77 49 -92 18 -265 66 -343 95 -109 41 -192 92 -263 164 -113 113 -173 241 -242 520 -21 85 -42 158 -46 162 -5 5 -14 5 -20 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022 1343 c-34 -162 -129 -253 -292 -279 -52 -8 -51 -20 3 -34 133 -34 197 -71 235 -132 11 -18 30 -67 42 -108 30 -104 30 -103 36 -98 2 3 12 34 21 69 39 158 104 223 262 262 93 24 93 22 -14 52 -153 43 -206 96 -244 247 -10 40 -23 74 -28 75 -5 2 -14 -23 -21 -54z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAi);
export default __webpack_public_path__ + "static/media/ico-ai.2215f26179773869ed06fbbefc1aa147.svg";
export { ForwardRef as ReactComponent };